import React, { createContext, useState, useEffect, ReactNode, useContext } from 'react';
import { useLocation } from 'react-router-dom';

interface GlobalState {
  isDevisPath: boolean;
  isRenouvellement: boolean;
}

interface GlobalContextType {
  globalState: GlobalState;
  setGlobalState: React.Dispatch<React.SetStateAction<GlobalState>>;
}

const defaultContextValue: GlobalContextType = {
  globalState: {
    isDevisPath: false,
    isRenouvellement: false,
  },
  setGlobalState: () => {},
};

const GlobalContext = createContext<GlobalContextType>(defaultContextValue);

interface GlobalProviderProps {
  children: ReactNode;
}

export const GlobalProvider: React.FC<GlobalProviderProps> = ({ children }) => {
  const [globalState, setGlobalState] = useState<GlobalState>({
    isDevisPath: false,
    isRenouvellement: false,
  });

  const location = useLocation();

  useEffect(() => {
    const isDevisPath = location.pathname.includes('quotation') || location.pathname.includes('order');
    const isRenouvellement = location.pathname.includes('renouvellement-de-benne');
    setGlobalState((prevState) => ({
      ...prevState,
      isDevisPath,
      isRenouvellement,
    }));
  }, [location]);

  return <GlobalContext.Provider value={{ globalState, setGlobalState }}>{children}</GlobalContext.Provider>;
};

const useGlobalContext = () => useContext(GlobalContext);
export default useGlobalContext;
